class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '4c038691';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1195.0.4';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Tue, 15 Sep 2026 17:50:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-09-15 13:50:19 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-09-15 13:50:19 Boston - 4c038691 - 1195.0.4';
export default BuildTags;
